import React from "react";
import {
    List, Button, Spin, Typography, Card, Modal, message, Space, Badge, Empty
} from 'antd';
import {
    ShoppingCartOutlined,
    DeleteOutlined,
    EyeOutlined,
    StarOutlined,
    LoadingOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import firebase from "../../firebase";
import FavoriteCartAllSelect from "../CartSelect/FavoriteCartAllSelect";
import FavoriteCartAllSelectOtasuke from "../CartSelect/FavoriteCartAllSelectOtasuke";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Text, Title } = Typography;

function pad(n) {
    return n > 9 ? "" + n : "0" + n;
}

class MobileFavorite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            carts: [],
            modal: false,
            cartselect: false,
            cartNo: null,
            selectedItem: null,
            deleteCartID: null,
            deleteCartName: null,
        };
    }

    getCollection = () => {
        const { db, org, userOrg } = this.props;
        if (org && org.reseller && userOrg && userOrg.maker) {
            return db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        } else if (org && org.maker && userOrg && userOrg.reseller) {
            return db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.reseller && userOrg && userOrg.buyer) {
            return db.collection('items_sell').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
        } else if (org && org.buyer && userOrg && userOrg.reseller) {
            return db.collection('items_sell').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
        }
        return null;
    }

    getCarts = async (nextProps) => {
        // === EXACT COPY of desktop Favorite.js getCarts logic ===
        let props = this.props;
        if (nextProps && nextProps.org && this.props.org !== nextProps.org) {
            props = nextProps;
        }

        let collection;
        if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.maker) {
            // manufacturer
            collection = this.props.db.collection('items_stock').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items');
        } else if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
            // Distributor/Purchase mode
            collection = this.props.db.collection('items_stock').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items');
        } else if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
            // purchasing user
            collection = this.props.db.collection('items_sell').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items');
        } else if (this.props.org && this.props.org.buyer && this.props.userOrg && this.props.userOrg.reseller) {
            // Distributor/sales mode
            collection = this.props.db.collection('items_sell').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items');
        }

        if (props.org && collection) {
            this.setState({ loading: true });

            let fsRef = props.db.collection('favorite_set').doc(props.user.id).collection('favorite_set').doc(props.org.id);
            let fs = await fsRef.get();
            let fsData = fs.data();
            console.log('fsData', fsData);
            if (fsData) {
                let hasChanged = false;
                for (let i = 0; i < 30; i++) {
                    let fCart = fsData[i];
                    if (fCart) {
                        let items = fCart.items;
                        if (items) {
                            delete fCart['deletedItem'];
                            delete fCart['deletedText'];
                            await Promise.all(items.map(async (item) => {
                                let itemSell = await collection.doc(item.id).get();
                                let itemSellData = itemSell.data();

                                let prevPrice = item.price;
                                let prevDeletedItem = item.deletedItem;
                                delete item['deletedItem'];
                                delete item['deletedText'];

                                if (!itemSellData) {
                                    fCart.deletedItem = true;
                                    fCart.deletedText = '販売終了商品が含まれています';
                                    item.deletedItem = true;
                                    item.deletedText = '販売終了商品が含まれています';
                                } else if (!itemSellData['price'] || itemSellData['price'][0] && !itemSellData['price'][0]['price']) {
                                    fCart.deletedItem = true;
                                    fCart.deletedText = '要見積商品が含まれています';
                                    item.deletedItem = true;
                                    item.deletedText = '要見積商品が含まれています';
                                } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                                    fCart.deletedItem = true;
                                    fCart.deletedText = '要見積商品が含まれています';
                                    item.deletedItem = true;
                                    item.deletedText = '要見積商品が含まれています';
                                } else if (itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                                    let expiration_date = itemSellData['price'][0]['expiration_date'];
                                    let expDate = expiration_date && expiration_date.toDate ? expiration_date.toDate() : (expiration_date ? new Date(expiration_date.seconds * 1000) : new Date(0));
                                    if ((expDate.getTime() - this.props.dateNow) < 0) {
                                        fCart.deletedItem = true;
                                        fCart.deletedText = '価格有効期限切れ要見積';
                                        item.deletedItem = true;
                                        item.deletedText = '価格有効期限切れ要見積';
                                    } else {
                                        item.price = itemSellData['price'][0]['price'];
                                    }
                                } else {
                                    item.price = itemSellData['price'][0]['price'];
                                }

                                if (!item.deletedItem) {
                                    let changed = updateItemFromSellData(item, itemSellData);
                                    if (changed) hasChanged = true;
                                }
                                if (prevDeletedItem !== item.deletedItem) {
                                    hasChanged = true;
                                }
                                if (prevPrice !== item.price && (prevPrice === undefined || Number(prevPrice) !== Number(item.price))) {
                                    hasChanged = true;
                                }
                            }));
                        }
                    }
                }
                if (hasChanged) {
                    await fsRef.set(fsData, { merge: true });
                }
                // console.log('fsData', fsData);
                this.setState({ carts: fsData });
            }
        }

        this.setState({ loading: false });
    }

    componentDidMount() {
        this.getCarts(this.props);
        window.addEventListener('scroll', event => this.watchCurrentPosition(), true);
    }

    componentDidUpdate(prevProps) {
        if (this.props.org !== prevProps.org || this.props.userOrg !== prevProps.userOrg) {
            this.getCarts(this.props);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', event => this.watchCurrentPosition(), true);
    }

    watchCurrentPosition() {
        if (window.innerHeight + this.scrollTop() + 20 >= document.body.clientHeight) {
            // scroll end
        }
    }

    scrollTop() {
        return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    }


    sendFavouriteCart = (cartIndex) => {
        this.setState({ selectedItem: this.state.carts[cartIndex], cartNo: cartIndex }, () => {
            this.setState({ cartselect: true });
        });
    }

    showHideCart = (val, cartId) => {
        this.setState({ cartselect: val });
        const { userOrg, org } = this.props;
        if (cartId) {
            if ((userOrg && userOrg.reseller && org && org.maker) || (userOrg && userOrg.buyer && org && org.reseller)) {
                message.success("カートへの追加が完了しました。");
            } else {
                message.success("お助けカートへの追加が完了しました。");
            }
        }
    }

    confirmDelete = (cartIndex, cartName) => {
        this.setState({ modal: true, deleteCartID: cartIndex, deleteCartName: cartName });
    }

    handleDelete = () => {
        const { db, user, org } = this.props;
        const deleteCartId = this.state.deleteCartID;

        const cartMainRef = db.collection('favorite_set').doc(user.id);
        const cartRef = cartMainRef.collection('favorite_set').doc(org.id);

        cartMainRef.set({ dummy: 'test' }, { merge: true });
        cartRef.set({
            [deleteCartId]: {},
            update: firebase.firestore.Timestamp.fromDate(new Date()),
        }, { merge: true }).then(() => {
            this.setState({ modal: false, deleteCartID: null, deleteCartName: null }, () => {
                this.getCarts();
                message.success("お気に入りセットを削除しました。");
            });
        });
    }

    render() {
        if (!this.props.org) {
            return (
                <div style={{ padding: 24, textAlign: 'center' }}>
                    <Text type="secondary">取引先を選択してください。</Text>
                </div>
            );
        }

        const { userOrg, org } = this.props;
        const isBuyer = (userOrg && userOrg.reseller && org && org.maker) ||
            (userOrg && userOrg.buyer && org && org.reseller);
        const buttonText = isBuyer ? "カートに追加" : "お助けカートに追加";

        // Build cart rows (0~29)
        const cartRows = [];
        for (let i = 0; i < 30; i++) {
            const cart = this.state.carts[i];
            if (cart && cart.items) {  // same as desktop: no length check
                const cartName = cart.cartName || '名称未設定';
                const deletedItem = cart.deletedItem;
                const archiveFilter = cart.items.filter(v => v.archive === true);

                let amount = 0;
                cart.items.forEach(item => {
                    if (!item.deletedItem) amount += (item.price || 0) * (item.count || 0);
                });

                cartRows.push({
                    index: i,
                    cartName,
                    items: cart.items,
                    amount,
                    deletedItem,
                    archiveFilter
                });
            } else {
                cartRows.push({
                    index: i,
                    cartName: '名称未設定',
                    items: [],
                    amount: 0,
                    deletedItem: false,
                    archiveFilter: []
                });
            }
        }

        return (
            <div style={{ padding: '8px 12px', paddingBottom: 60, background: '#f5f5f5', minHeight: '100vh' }}>
                {/* Header */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '12px 4px 8px',
                    marginBottom: 8
                }}>
                    <StarOutlined style={{ fontSize: 22, color: '#faad14' }} />
                    <Title level={5} style={{ margin: 0 }}>お気に入りセット一覧</Title>
                </div>

                {this.state.loading ? (
                    <div style={{ textAlign: 'center', padding: 40 }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 28 }} spin />} />
                    </div>
                ) : cartRows.length === 0 ? (
                    <Empty description="お気に入りセットがありません" style={{ marginTop: 60 }} />
                ) : (
                    <List
                        dataSource={cartRows}
                        renderItem={(row) => (
                            <Card
                                key={row.index}
                                style={{
                                    marginBottom: 12,
                                    borderRadius: 12,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
                                }}
                                bodyStyle={{ padding: '14px 16px' }}
                            >
                                {/* Cart name + set no */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                                    <Space>
                                        <Badge count={pad(row.index + 1)} style={{ backgroundColor: '#1677ff' }} />
                                        <Text strong style={{ fontSize: 16 }}>{row.cartName}</Text>
                                    </Space>
                                    {row.deletedItem && (
                                        <Text type="danger" style={{ fontSize: 11 }}>⚠ {this.state.carts[row.index]?.deletedText}</Text>
                                    )}
                                    {row.archiveFilter.length > 0 && (
                                        <Text type="danger" style={{ fontSize: 11 }}>⚠ アーカイブ商品含む</Text>
                                    )}
                                </div>

                                {/* Cart items list */}
                                <div style={{ marginBottom: 10 }}>
                                    {row.items.length > 0 ? (
                                        row.items.map((item, idx) => (
                                            <div key={idx} style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '4px 0',
                                                borderBottom: idx < row.items.length - 1 ? '1px solid #f0f0f0' : 'none'
                                            }}>
                                                <div style={{ flex: 1 }}>
                                                    <Text
                                                        style={{ fontSize: 13, display: 'block' }}
                                                        type={item.deletedItem || item.archive ? 'danger' : undefined}
                                                    >
                                                        {item.name}
                                                        {item.deletedItem && <><br /><Text type="danger" style={{ fontSize: 11 }}>{item.deletedText}</Text></>}
                                                        {item.archive && <><br /><Text type="danger" style={{ fontSize: 11 }}>{isBuyer ? '取扱していない商品が含まれています' : 'アーカイブ商品が含まれています'}</Text></>}
                                                    </Text>
                                                </div>
                                                <Text style={{ fontSize: 12, color: '#999', marginLeft: 8 }}>×{item.count}</Text>
                                            </div>
                                        ))
                                    ) : (
                                        <Text type="secondary" style={{ fontSize: 13 }}>空です</Text>
                                    )}
                                </div>

                                {/* Amount */}
                                {row.amount > 0 ? (
                                    <div style={{ textAlign: 'right', marginBottom: 10 }}>
                                        <Text type="secondary" style={{ fontSize: 12 }}>合計: </Text>
                                        <Text strong style={{ color: '#d32f2f' }}>¥{row.amount.toLocaleString()}</Text>
                                    </div>
                                ) : (
                                    <div style={{ textAlign: 'right', marginBottom: 10 }}>
                                        <Text type="secondary" style={{ fontSize: 12 }}>合計: </Text>
                                        <Text strong style={{ color: '#999' }}>-</Text>
                                    </div>
                                )}

                                {/* Action buttons */}
                                <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }}>
                                    <Link to={`/favorite/cart/${row.index + 1}`} style={{ flex: 1 }}>
                                        <Button
                                            icon={<EyeOutlined />}
                                            style={{ width: '100%' }}
                                        >
                                            詳細
                                        </Button>
                                    </Link>
                                    <Button
                                        type="primary"
                                        icon={<ShoppingCartOutlined />}
                                        style={{ flex: 2 }}
                                        disabled={row.items.length === 0 || row.deletedItem || row.archiveFilter.length > 0}
                                        onClick={() => this.sendFavouriteCart(row.index)}
                                    >
                                        {buttonText}
                                    </Button>
                                    {row.items.length > 0 ? (
                                        <Button
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => this.confirmDelete(row.index, row.cartName)}
                                        />
                                    ) : (
                                        <Button
                                            disabled
                                            icon={<DeleteOutlined />}
                                        />
                                    )}
                                </div>
                            </Card>
                        )}
                    />
                )}

                {/* Cart select modal */}
                {isBuyer ? (
                    <FavoriteCartAllSelect
                        isOpen={this.state.cartselect}
                        isOpenEvent={(val, cartId) => this.showHideCart(val, cartId)}
                        favouriteCartId={this.state.cartNo}
                        db={this.props.db}
                        user={this.props.user}
                        data={this.state.selectedItem}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                ) : (
                    <FavoriteCartAllSelectOtasuke
                        isOpen={this.state.cartselect}
                        isOpenEvent={(val, cartId) => this.showHideCart(val, cartId)}
                        favouriteCartId={this.state.cartNo}
                        db={this.props.db}
                        user={this.props.user}
                        data={this.state.selectedItem}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                )}

                {/* Delete confirm modal */}
                <Modal
                    title="お気に入りセット削除"
                    open={this.state.modal}
                    onOk={this.handleDelete}
                    onCancel={() => this.setState({ modal: false, deleteCartID: null, deleteCartName: null })}
                    okText="削除する"
                    cancelText="キャンセル"
                    okButtonProps={{ danger: true }}
                    centered
                >
                    <p>お気に入りセット「<strong>{this.state.deleteCartName}</strong>」を削除します。よろしいですか？</p>
                </Modal>
            </div>
        );
    }
}

export default MobileFavorite;
